<template>
  <section
    v-if="excessForm.length>0"
    class="excess-form">
    <div class="box">
      <h3>Optional Benefits</h3>
      <v-checkbox-group
        v-model="benefits"
        :isColumn="false"
        :disabled="disabled"
        :labelKey="'name'"
        :valueKey="'id'"
        :list="excessForm"
        @change="handlerBenefits">
      </v-checkbox-group>
      <!--      <div-->
      <!--        v-for="(excessItem, excessIndex) in excessForm"-->
      <!--        :key="excessIndex"-->
      <!--      >-->
      <!--        <span>{{ excessItem.label_1 }}</span>-->
      <!--        <div-->
      <!--          v-for="(item, index) in excessItem.details_1"-->
      <!--          :key="index">-->
      <!--          <div class="form-item">-->
      <!--            <span>{{ item.label_2}}</span>-->
      <!--            <div class="flex-sb">-->
      <!--              <template>-->
      <!--                <div-->
      <!--                  v-if="item.field_1"-->
      <!--                  class="form-half">-->
      <!--                  <v-input-->
      <!--                    v-model="item.default_vl_1"-->
      <!--                    :disbaled="item.is_disable==1"-->
      <!--                  />-->
      <!--                </div>-->
      <!--                <div-->
      <!--                  v-if="item.field_2"-->
      <!--                  class="form-half">-->
      <!--                  <v-input-->
      <!--                    v-model="item.default_vl_2"-->
      <!--                    :disbaled="item.is_disable==1"-->
      <!--                  />-->
      <!--                </div>-->
      <!--              </template>-->

      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getReferralPlanBenefit} from '@/api/refer'
import {getRenewalPlanBenefit} from '@/api/renewal'

export default {
  name: 'moreBenefit',
  mixins: [MixinOptions],
  props: {
    classId: {
      type: [Number, String],//14 motor 21 domestic 24 decoration 26 home &fire
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    },
    referId: {
      type: [String, Number],
      default: ''
    },
    formDataLock: {
      type: Number,
      default: 0,
    },
    disabled:{
      type:Boolean,
      default:false
    },
    index: {
      type: Number,
      default: 0
    },
    editType: {
      type: Number,
      default: 0
    },
    renewOrderId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      oldFormDataLock: -1,
      excessForm: [],
      benefits:[]
    }
  },
  computed:{
    group_name(){
      let benefitObj  = this.excessForm.reduce((result, item)=>{
        if(item.is_group==1){
          result[item.group_name] = []
        }
        return result
      },{})
      return benefitObj
    },
    benefitsGroup(){
      let obj = this.group_name
      this.excessForm.some((item)=>{
        if(item.is_group==1){
          obj[item.group_name].push(item.id)
        }
      })
      return obj
    }
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      immediate: true,
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
          if([11,12,14].includes(this.classId))
          {
            let {company_id,trm_of_cvr,refer_id} = this.form||{}
            if(company_id&&trm_of_cvr)
            {
              let params = {
                company_id,
                plan_id:trm_of_cvr,
                refer_id,
                order_id: this.renewOrderId
              }
              this.$nextTick(() => {
                this.network().getReferralPlanBenefit(params)
              })
            }
          }
        }
      }
    },
    classId: {
      immediate: true,
      handler(val) {
        if (val) {
          if([11,12,14,21,23,25,26,27].includes(val))
          {
            let {company_id,trm_of_cvr,refer_id} = this.form||{}
            if(company_id&&trm_of_cvr)
            {
              let params = {
                company_id,
                plan_id:trm_of_cvr,
                refer_id,
                order_id: this.renewOrderId
              }
              this.$nextTick(() => {
                this.network().getReferralPlanBenefit(params)
              })
            }
          }
        }
      }
    },
    'form.plan_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val && this.formDataLock !== this.oldFormDataLock) {
          this.oldFormDataLock = this.formDataLock
          const { company_id, plan_id, refer_id} = this.form
          let params = {
            company_id,
            plan_id,
            refer_id,
            order_id: this.renewOrderId
          }
          if(![11,12,14].includes(this.classId))
            this.$nextTick(() => {
              this.network().getReferralPlanBenefit(params)
            })
        }
      }
      // }
    },
    benefits:{
      immediate:true,
      handler(val = [], old=[]) {
        const params ={
          benefits: val,
        }
        this.$emit('getSubmitPremium', params, this.index, 'benefit')
        if([11,12,21,23,25,26,27].includes(Number(this.classId))) {
          this.handlerBenefits()
          let benefitsGroup
          if( this.classId == 11){
            benefitsGroup = {
              group_11:[256, 512]
            }
          }else {
            benefitsGroup  = this.benefitsGroup
          }
          // 判斷有多少個是衝突的
          Object.keys(benefitsGroup).some(key=>{
            let arr = benefitsGroup[key]
            const filterList = val.filter(item => arr.includes(item))
            if(filterList.length > 1) {
              let flag = false
              const result = val.reduce((result, item) => {
                if(arr.includes(item) && !flag) {
                  flag = true
                  return result
                }
                result.push(item)
                return result
              }, [])
              this.benefits = JSON.parse(JSON.stringify(result))
            }
          })
        }
      }
    },
  },
  methods: {
    handlerBenefits(){
      let unSelectKeys = this.excessForm.reduce((result, item) => {
        if(!this.benefits.includes(item.id) && item.is_group){
          result.push(item.key)
        }
        return result
      },[])
      const params ={
        benefits:this.benefits,
        unSelectKeys
      }
      this.$emit('getSubmitPremium', params, this.index, 'benefit')
    },
    submitForm(formName) {
      // const params = JSON.parse(JSON.stringify(this.excessForm))
      const params ={
        benefits:this.benefits
      }
      this.$emit('getFormData', formName,params,this.index)
    },
    network() {
      return {
        getReferralPlanBenefit: async (params) => {

          // if(this.referId) {
          //   params.refer_id = this.referId
          // }
          if(this.editType == 3){
            if(params.order_id > 0){
              var { data } = await getRenewalPlanBenefit({
                ...params,
                hideLoading: true
              })
            }
          }else{
            var { data } = await getReferralPlanBenefit({
              ...params,
              hideLoading: true
            })
          }
          if(data){
            this.excessForm = []
            this.benefits = []
            data.some(item=>{
              if(item.is_selected==1)
                this.benefits.push(item.id)
              if(item.is_show!=0)
                this.excessForm.push({id:item.id,name:item.name,key:item.key, is_group:item.is_group,group_name:item.group_name})
            })
            let {benefits} = this.form||{}

            if(benefits)
              this.benefits = JSON.parse(JSON.stringify(benefits))
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 50%;
}
.excess-form {
  .flex-excess {
    display: flex;
    align-items: center;
    & > .el-checkbox {
      margin: 0 15px;
    }
    & > span {
      display: inline-block;
      padding: 0 15px;
    }
  }
  .form-excess-half {
    width: 500px;
  }
}
</style>
